/* Gift merchandise is managed here; its price is always decided by Shopify. */
(() => {
  const configNode = document.getElementById('ClyGiftConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const marker = 'two-pairs-v1';
  let queue = Promise.resolve();
  const isGift = item => String(item.product_id) === String(config.productId);
  const managed = item => isGift(item) && item.properties?._cly_gift === marker;
  const pairs = cart => cart.items.reduce((sum, item) => sum + (
    !isGift(item) && item.final_line_price > 0 && item.options_with_values?.some(option => option.name.toLowerCase().trim() === 'pointure') ? item.quantity : 0
  ), 0);
  async function request(url, body) {
    const response = await fetch(url, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'}});
    const data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || (window.CarmelynaTranslations || {}).giftRefreshFailed);
    return data;
  }
  const read = () => request(`${window.routes.cart_url}.js`);
  async function reconcile() {
    let cart = await read();
    const eligible = pairs(cart) >= 2;
    const gifts = cart.items.filter(managed);
    const otherGift = cart.items.some(item => isGift(item) && !managed(item));
    const updates = {};
    gifts.forEach((item, index) => {
      const wanted = eligible && !otherGift && index === 0 ? 1 : 0;
      if (item.quantity !== wanted) updates[item.key] = wanted;
    });
    if (Object.keys(updates).length) cart = await request(window.routes.cart_update_url,{updates});
    if (eligible && !cart.items.some(isGift) && config.variantId) {
      try {
        await request(window.routes.cart_add_url,{items:[{id:config.variantId,quantity:1,properties:{_cly_gift:marker}}]});
      } catch (_) {
        // The customer's paid products stay in the cart even if the gift is unavailable.
      }
      cart = await read();
    }
    // Never leave an automatically added gift charged at its retail price.
    const charged = cart.items.filter(item => managed(item) && item.final_line_price > 0);
    if (charged.length) {
      const removals = Object.fromEntries(charged.map(item => [item.key,0]));
      cart = await request(window.routes.cart_update_url,{updates:removals});
    }
    return cart;
  }
  async function afterMutation(result, sections = ['cart-drawer','cart-icon-bubble']) {
    if (!config.enabled || !config.productId || result.errors || result.status) return result;
    const task = async () => {
      let cart;
      try { cart = await reconcile(); }
      catch (_) { window.location.assign(window.routes.cart_url); throw new Error((window.CarmelynaTranslations || {}).cartCheckFailed); }
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('sections', [...new Set(sections)].join(','));
      let html;
      try { html = await request(url.pathname + url.search); }
      catch (_) { window.location.assign(window.routes.cart_url); throw new Error((window.CarmelynaTranslations || {}).cartCheckFailed); }
      if (sections.some(id => !html[id])) {window.location.assign(window.routes.cart_url);throw new Error((window.CarmelynaTranslations || {}).cartRefreshRequired);}
      return {...result,...cart,sections:html};
    };
    const next = queue.then(task,task);
    queue = next.catch(()=>{});
    return next;
  }
  window.CarmelynaGift = {afterMutation};
  // Also protects a full cart page restored from a bookmark or a failed request.
  document.addEventListener('submit', event => {
    if (!config.enabled || event.submitter?.name !== 'checkout') return;
    if (document.querySelector('[data-cly-charged-gift]')) {
      event.preventDefault();
      const notice = document.querySelector('[data-cly-gift-notice]');
      if (notice) {notice.hidden=false;notice.textContent=(window.CarmelynaTranslations || {}).giftUpdateNotice;notice.focus();}
    }
  },true);
})();